import { Destination } from "common/router/types";

import { basePath } from "./index";

export type AuthoredLinkProps = { dest: Destination } | { href: string; newTab: boolean };

/**
 * Link props for a URL authored in admin (a deal card, a header alert). The client router owns
 * only plain storefront paths, so a path carrying a query or hash, or one outside the storefront,
 * is an anchor the browser follows; an http(s) URL opens in a new tab; anything else is not a link.
 */
export const authoredLinkProps = (url: string): AuthoredLinkProps | null => {
  if (/^https?:\/\//i.test(url)) {
    return { href: url, newTab: true };
  }
  if (!url.startsWith("/") || url.startsWith("//")) {
    return null;
  }
  if (url.startsWith(`${basePath}/`) && !/[?#]/.test(url)) {
    return { dest: { to: url } };
  }
  return { href: url, newTab: false };
};
